import './Instruments.css';
import Frame from "../common/Frame";
import {appdata, load, save} from "../../logic_tmp/appdata/AppData";
import {CountryDropdown} from "react-country-region-selector";
import React, {useEffect, useState} from "react";
import {useHistory} from "react-router-dom";
import {MySpinner} from "../common/MySpinner";
import Paysera from "./paysera/paysera";
import Montonio from "./montonio/montonio";
import {useTranslation} from "react-i18next";
import {registerConcersion} from "../../logic/funel/FacebookUtils";
import {init} from "../../backend/connectors/JavaConnector";
import {logError, logInfo, logPageOpened} from "../model/utils";

function useForceUpdate() {
    const [value, setValue] = useState(0); // integer state
    return () => setValue(value => value + 1); // update the state to force render
}

let errorMessage = "";
let busy = "";


export function Instruments_new() {
    const [showAdd, setShowAdd] = useState(false);
    const history = useHistory();
    const forceUpdate = useForceUpdate();
    load();
    const {t} = useTranslation();


    useEffect(() => {
        registerConcersion('InitiateCheckout');
        logPageOpened(window.location.pathname, "Pay")
    }, [])

    function selectCountry(val) {
        appdata.country = val;
        save();
        forceUpdate();
    }

    function selectInstrument(paymentMethod, instrument, nextPage, spinnerKey) {
        console.log("selectInstrument: method=" + paymentMethod + " instrument=" + instrument + " nextPage=" + nextPage + " amount=" + appdata.amount + " count=" + appdata.count + " productCode=" + appdata.productCode)
        logInfo("selectInstrument: method=" + paymentMethod + " instrument=" + instrument + " nextPage=" + nextPage,
            {paymentMethod, instrument, nextPage, amount: appdata.amount, count: appdata.count})
        registerConcersion('AddPaymentInfo');
        if ("BILL-REQUEST" === paymentMethod || "CASH-REQUEST" === paymentMethod || "PAPERTICKET-REQUEST" === paymentMethod)
            registerConcersion('Purchase', {value: appdata.amount, currency: 'EUR'});
        errorMessage = "";
        if (busy === spinnerKey) return;
        busy = spinnerKey;
        forceUpdate();
        appdata.paymentMethod = paymentMethod;
        appdata.paymentInstrument = instrument;
        console.log("selectInstrument: calling init lambda...")
        init()
            .then(response => {
                console.log("selectInstrument: init responded status=" + response.status + " orderId=" + appdata.orderId + " redirectData=" + appdata.redirectData)
                logInfo("selectInstrument: init responded status=" + response.status,
                    {status: response.status, orderId: appdata.orderId, redirectData: appdata.redirectData})
                if (response.status !== 200) {
                    errorMessage = response.statusText;
                    forceUpdate();
                    return;
                }
                if (nextPage === "REDIRECT") {
                    if (appdata.redirectData === undefined || appdata.redirectData === null || appdata.redirectData.trim().length < 1) {
                        console.log("selectInstrument: EMPTY redirectData, redirect skipped!")
                        logInfo("selectInstrument: EMPTY redirectData, redirect skipped!", {orderId: appdata.orderId})
                        errorMessage = t("TechnicalErrorMessage") !== "TechnicalErrorMessage" ? t("TechnicalErrorMessage") : "Technical error, please try again";
                        forceUpdate();
                        return;
                    }
                    console.log("selectInstrument: redirecting to " + appdata.redirectData)
                    logInfo("selectInstrument: redirecting to payment system", {redirectData: appdata.redirectData})
                    window.open(appdata.redirectData, "_top");
                } else {
                    console.log("selectInstrument: navigating to " + nextPage)
                    history.push(nextPage);
                }
            })
            .catch((error) => {
                console.log("selectInstrument: init FAILED: " + error.message)
                logError(error)
                logInfo("selectInstrument: init call failed", {
                    errorMessage: error.message,
                    responseStatus: (error.response !== undefined) ? error.response.status : "no-response",
                    responseData: (error.response !== undefined) ? JSON.stringify(error.response.data) : ""
                })
                errorMessage = error.message;
                forceUpdate();
            })
            .finally(() => {
                busy = "";
                forceUpdate();
            });
    }

    return (
        <div>
            <Frame>
                <br/>

                <CountryDropdown
                    valueType="short"
                    value={appdata.country}
                    onChange={(val) => selectCountry(val)}/>
                <h2 className="offer-pay__title" id="selectInstrument">
                    {t("SelectPaymentInstrument")}
                </h2>
                <div className="App">
                </div>
                <br/>
                <p className="app-text">
                    {errorMessage}
                </p>
                {true || !"EE,LV,LT".includes(appdata.country) ?
                    (busy === "PAYSERA") ? <MySpinner/> :
                        <Paysera action={(par1) => selectInstrument("PAYSERA", par1, "REDIRECT", "PAYSERA")}/>
                    :
                    busy === "MONTONIO" ? <MySpinner/> :
                        <Montonio action={(par1) => selectInstrument("MONTONIO", par1, "REDIRECT", "MONTONIO")}/>

                }
                <div className="app-button d-flex justify-content-around">
                    <button onClick={() => selectInstrument("STRIPE", "card", "/stripe", "STRIPE")}
                            className="app-btn1">
                        {busy === "STRIPE" ? <MySpinner/> : <span><img src="img/Cards.png" alt=""/></span>}
                    </button>
                </div>
                {(appdata.product.cashPayments !== undefined) ?
                    <div className="app-button d-flex justify-content-around">
                        <button id="cashRequest" onClick={() => {
                            history.push("/cash");
                        }} className="app-btn4">
                            <img src="img/Cash.jpg" alt=""/>
                        </button>
                    </div> : <div></div>
                }
                <div className="app-button d-flex justify-content-around">
                    <button onClick={() => selectInstrument("PAYPAL", "Paypal", "/paypal", "PAYPAL")}
                            className="app-btn2">
                        {busy === "PAYPAL" ? <MySpinner/> : <span><img src="img/PayPal.png" alt=""/></span>}
                    </button>
                </div>
                <div className="app-button d-flex justify-content-around">
                    <button onClick={() => selectInstrument("STRIPE", "card", "/stripe", "GOOGLE")}
                            className="app-btn3">
                        {busy === "GOOGLE" ? <MySpinner/> : <span><img src="img/GoogleApple.png" alt=""/></span>}
                    </button>
                </div>
                {showAdd ?
                    <div>
                        <br/>
                        <br/>
                        <h2 className="offer-pay__text" id="selectInstrument">
                            {t("BillOptionDescription")}
                        </h2>
                        <div className="app-button d-flex justify-content-around">
                            <button id="nextButton" type="submit" onClick={() => {
                                appdata.messageKey = "BillRequestAccepted"
                                save()
                                selectInstrument("BILL-REQUEST", "reservation", "/genericMessage", "BILL")
                            }}
                                    className="q-btn app-btn-further next-step-btn">
                                {busy === "BILL" ? <MySpinner/> : <span>{t("BillOptionAction")}</span>}
                            </button>
                        </div>
                        <br/>
                        <br/>
                        {(false) ?
                            <div>
                                <h2 className="offer-pay__text" id="selectInstrument">
                                    {t("CashOptionDescription")}

                                </h2>

                                <div className="app-button d-flex justify-content-around">
                                    <button id="nextButton" type="submit"
                                            onClick={() => {
                                                appdata.messageKey = "CashRequestAccepted"
                                                save()
                                                selectInstrument("CASH-REQUEST", "reservation", "/genericMessage", "CASH")}}
                                            className="q-btn app-btn-further next-step-btn">
                                        {busy === "CASH" ? <MySpinner/> : <span>{t("CashOptionAction")}</span>}
                                    </button>
                                </div>
                                <br/>
                                <br/>
                                <h2 className="offer-pay__text" id="selectInstrument">
                                    {t("PaperOptionDescription")}
                                </h2>
                                <div className="app-button d-flex justify-content-around">
                                    <button id="nextButton" type="submit"
                                            onClick={() => {
                                                appdata.messageKey = "PaperTicketRequestAccepted"
                                                save()
                                                selectInstrument("PAPERTICKET-REQUEST", "reservation", "/genericMessage", "PAPER")}}
                                            className="q-btn app-btn-further next-step-btn">
                                        {busy === "PAPER" ? <MySpinner/> : <span>{t("PaperOptionAction")}</span>}
                                    </button>
                                </div>
                            </div>:<div></div>}

                        <br/>
                        <br/>
                        <div className="app-button d-flex justify-content-around">
                            <button id="nextButton" type="submit"
                                    onClick={() => {
                                        appdata.messageKey = "PhoneRequestAccepted"
                                        save()
                                        selectInstrument("PHONE-REQUEST", "reservation", "/genericMessage", "PHONE")}}
                                    className="q-btn app-btn-further next-step-btn">
                                {busy === "PHONE" ? <MySpinner/> : <span>{t("PhoneOptionAction")}</span>}
                            </button>
                        </div>
                    </div> : <div>
                        {(appdata.product["productData"] !== undefined && appdata.product["productData"]["additionalPaymentMethods"] === "hide")? <div></div>:
                            <div className="app-button d-flex justify-content-around">
                                {false?
                                <button id="nextButton" type="submit" onClick={() => {setShowAdd(true)}} className="q-btn app-btn-further next-step-btn">{t("PaymentOptions")}</button>
                                    :<div/>}
                            </div>}
                    </div>
                }
            </Frame>
        </div>
    );
}
